module.exports = __webpack_public_path__ + "static/media/captainPlanet.e9e09274.jpg";